import axios from 'axios'

// API 視覺辨識模型
// API Doc: https://hackmd.io/0NCwOaW9QZm5x4-SayLN-w
const model = axios.create({
  baseURL: 'https://taoyuan-odb.webduino.tw/api/detector'
})

export const GET_MODEL = (url, parameter = {}) => model.get(url, parameter)
export const POST_IDENTIFICATION_RESULT = (url, data = {}, config = {}) => model.post(url, data, config)
